export { default } from './WelcomeOnBoardNote'
